import { useNavigate } from 'react-router-dom';

export default function NotImplementedPage() {
  const navigate = useNavigate();

  return (
    // <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 flex items-center justify-center">
      <div className="max-w-2xl mx-auto px-4 py-16 text-center">
        <div className="mb-8">
          <img 
            src="https://storage.googleapis.com/uxpilot-auth.appspot.com/7f4fb021f1-f35dac0896ca43e0ce0d.png" 
            alt="Under Construction" 
            className="w-48 h-48 mx-auto mb-6 animate-bounce"
          />
          <h1 className="text-4xl font-bold text-neutral-800 mb-4">
            Coming Soon
          </h1>
          <p className="text-lg text-neutral-600 mb-8">
            This page is under construction. We're working hard to bring you something amazing!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate(-1)}
              className="px-6 py-3 bg-neutral-800 text-white rounded-lg hover:bg-neutral-700 transition-colors flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-arrow-left"></i>
              Go Back
            </button>
            <button
              onClick={() => navigate('/')}
              className="px-6 py-3 bg-white text-neutral-800 border border-neutral-300 rounded-lg hover:bg-neutral-50 transition-colors flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-house"></i>
              Go to Home
            </button>
          </div>
        </div>
        <div className="mt-12 p-6 bg-white rounded-xl shadow-lg border">
          <h2 className="text-xl font-semibold mb-4">
            What's Coming?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-neutral-100 flex items-center justify-center flex-shrink-0">
                <i className="fa-solid fa-wand-magic-sparkles text-neutral-600"></i>
              </div>
              <div>
                <h3 className="font-medium">New Features</h3>
                <p className="text-sm">Exciting new functionality coming soon</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-neutral-100 flex items-center justify-center flex-shrink-0">
                <i className="fa-solid fa-paint-brush text-neutral-600"></i>
              </div>
              <div>
                <h3 className="font-medium">Improved Design</h3>
                <p className="text-sm">Enhanced user interface and experience</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-neutral-100 flex items-center justify-center flex-shrink-0">
                <i className="fa-solid fa-bolt text-neutral-600"></i>
              </div>
              <div>
                <h3 className="font-medium">Better Performance</h3>
                <p className="text-sm">Faster loading and smoother interactions</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-neutral-100 flex items-center justify-center flex-shrink-0">
                <i className="fa-solid fa-shield-halved text-neutral-600"></i>
              </div>
              <div>
                <h3 className="font-medium">Enhanced Security</h3>
                <p className="text-sm">Improved data protection and privacy</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    // </div>
  );
} 